import * as React from 'react';
import { JRCTooltip, JRCTooltipProps } from '../JRCTooltip/JRCTooltip';
import { useIntl } from 'react-intl';

export interface JRCConditionalWrapperProps {
    condition: boolean;
    wrapper: (children: React.ReactNode) => React.ReactNode;
    wrapperFalse?: (children: React.ReactNode) => React.ReactNode;
    children?: React.ReactNode;
}

export const JRCConditionalWrapper = ({ condition, wrapper, wrapperFalse, children }: JRCConditionalWrapperProps) => (
    <>{condition ? wrapper(children) : wrapperFalse ? wrapperFalse(children) : children}</>
);

export interface JRCConditionalTooltipProps {
    condition?: boolean;
    hasLicense?: boolean;
    tooltip?: Omit<JRCTooltipProps, 'children'>;
    children?: React.ReactNode;
    className?: string;
}

export const JRCConditionalTooltip = ({
    condition,
    hasLicense = true,
    tooltip,
    children,
    className,
}: JRCConditionalTooltipProps) => {
    const intl = useIntl();

    const noLicenseTooltipProps = {
        description: intl.formatMessage({
            id: 'GLOBAL_Action_Missing_License',
        }),
    };

    return (
        <JRCConditionalWrapper
            condition={(condition && !!tooltip) || !hasLicense}
            wrapper={(children) => (
                <JRCTooltip
                    {...(hasLicense ? (tooltip as JRCTooltipProps) : noLicenseTooltipProps)}
                    className={className}>
                    {children}
                </JRCTooltip>
            )}>
            {children}
        </JRCConditionalWrapper>
    );
};
